module.exports = __webpack_public_path__ + "static/footer-logo-e33f426c7d9f021c61bb2d1ed3b7d585.png";